// TOUR-14 — Location Tools walkthrough (URL substitutions + per-lot overrides).

import type { FireflyTourArtifact } from "../tourTypes";

export const LOCATION_TOOLS_TOUR_ID = "tour-location-tools";

export const LOCATION_TOOLS_TOUR: FireflyTourArtifact = {
  id: LOCATION_TOOLS_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "location tools tour",
    "set lot links",
    "location substitutions",
    "how do i set location links",
    "per location url overrides",
    "location links tour",
    "lot url configuration",
  ],
  bucketRelevance: ["manager"],
  requiredRoles: ["trainer", "marketing", "admin"],
  steps: [
    {
      id: "nav-location-tools",
      target: {
        mode: "locationTools",
        anchorId: "mode-nav-locationTools",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "locationTools",
      copy: {
        title: "Open Location Tools",
        body: "Configure org-wide link defaults and per-lot URL overrides used on the Leads screen. Tap Location Tools in the Manager bucket (sidebar or bottom bar).",
      },
      waitForClick: true,
    },
    {
      id: "lt-surface",
      target: { mode: "locationTools", anchorId: "lt-surface", scrollIntoView: true },
      copy: {
        title: "Location Tools hub",
        body: "Location links power the Location Links panel reps open on Leads. Sales daily checklist is configured here too — this tour focuses on URL substitutions.",
      },
      advanceOn: "next_button",
    },
    {
      id: "links-section",
      target: { mode: "locationTools", anchorId: "lt-links-tile", scrollIntoView: true },
      copy: {
        title: "Location links",
        body: "Expand Location links to edit org defaults, custom link types, and per-lot overrides.",
      },
      waitForClick: true,
    },
    {
      id: "mode-picker",
      target: { mode: "locationTools", anchorId: "lt-mode-picker", scrollIntoView: true },
      copy: {
        title: "Edit mode",
        body: "Edit link types sets org-wide defaults plus override columns per location. Edit links by location starts from a lot tile — pick the mode that matches your workflow.",
      },
      advanceOn: "next_button",
    },
    {
      id: "link-types-grid",
      target: { mode: "locationTools", anchorId: "lt-link-types-grid", scrollIntoView: true },
      copy: {
        title: "Link types",
        body: "Select a link type to set the org default URL and per-location overrides. Blank overrides inherit the org default — reps see the resolved link on Leads.",
      },
      advanceOn: "next_button",
    },
    {
      id: "save-links",
      target: { mode: "locationTools", anchorId: "lt-save-links", scrollIntoView: true },
      copy: {
        title: "Save to organization",
        body: "Save to organization persists link defaults and overrides for the scoped org. Changes apply on the next Leads session after save.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "locationTools", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Reps consume these links from Leads — not this editor. Ask Firefly anytime for capture or console tours from Sales modes.",
      },
      advanceOn: "next_button",
    },
  ],
};
